/**
 * Zento AI Embeddable Widget
 * 
 * This is the main entry point for the widget.
 * It can be loaded via a <script> tag and will automatically initialize
 * if configuration is provided in window.ZentoWidgetConfig.
 * 
 * Usage:
 * 
 * <script>
 *   window.ZentoWidgetConfig = {
 *     apiKey: 'your-api-key'
 *   };
 * </script>
 * <script src="https://cdn.zento.ai/widget.js" async></script>
 * 
 * Or manually:
 * 
 * const widget = new ZentoWidget({ apiKey: 'your-api-key' });
 * widget.init();
 */

import { ZentoWidget, ZentoWidgetConfig } from './widget';

// Export for manual usage
export { ZentoWidget };
export type { ZentoWidgetConfig };

// Extend Window interface
declare global {
  interface Window {
    ZentoWidget: typeof ZentoWidget;
    ZentoWidgetConfig?: ZentoWidgetConfig;
    zentoWidget?: ZentoWidget;
  }
}

// Make widget class available globally
window.ZentoWidget = ZentoWidget;

/**
 * Auto-initialize widget if config is present
 */
function autoInit(): void {
  const config = window.ZentoWidgetConfig;

  if (config && config.apiKey) {
    console.log('[ZentoWidget] Auto-initializing with config');

    const widget = new ZentoWidget(config);
    widget.init().catch((error) => {
      console.error('[ZentoWidget] Auto-init failed:', error);
    });

    // Store reference globally for debugging
    window.zentoWidget = widget;
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', autoInit);
} else {
  // DOM already loaded
  autoInit();
}

// Also check after a short delay (in case config is set after script loads)
setTimeout(() => {
  if (!window.zentoWidget && window.ZentoWidgetConfig?.apiKey) {
    autoInit();
  }
}, 100);



